import { GObjectType, GField } from "../graphql";

import { Location } from "./Location";

// TODO: move this into api graphql types definitions
@GObjectType("WishlistLocations")
export class WishlistLocations {
    @GField(() => [Location])
    cities: Location[];

    @GField(() => [Location])
    stops: Location[];
}
